/* Klemm Design — client-side enhancements */
(function () {
  const KL = {};

  /* --- Reveal-on-scroll --- */
  function initReveal() {
    const els = document.querySelectorAll('.klemm-reveal');
    if (!('IntersectionObserver' in window) || els.length === 0) {
      els.forEach((el) => el.classList.add('in'));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('in');
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );
    els.forEach((el) => io.observe(el));
  }

  /* --- Nav scrolled state --- */
  function initNavScrolled() {
    const header =
      document.querySelector('header-component') ||
      document.querySelector('.header') ||
      document.querySelector('header');
    if (!header) return;
    const onScroll = () => {
      header.classList.toggle('scrolled', window.scrollY > 20);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* --- Local time for hero meta-right --- */
  function initLocalTime() {
    const el = document.getElementById('klemm-localtime');
    if (!el) return;
    function tick() {
      const d = new Date();
      const hh = String(d.getHours()).padStart(2, '0');
      const mm = String(d.getMinutes()).padStart(2, '0');
      const ss = String(d.getSeconds()).padStart(2, '0');
      el.innerHTML =
        'Lokalzeit&nbsp;' +
        hh +
        ':' +
        mm +
        '<span style="color:var(--klemm-ink-dim)">:' +
        ss +
        '</span>';
    }
    tick();
    setInterval(tick, 1000);
  }

  /* --- Marquee: duplicate contents for seamless loop --- */
  function initMarquee() {
    document.querySelectorAll('.klemm-marquee-track[data-auto-loop]').forEach((track) => {
      if (track.dataset.cloned === '1') return;
      track.insertAdjacentHTML('beforeend', track.innerHTML);
      track.dataset.cloned = '1';
    });
  }

  /* --- Hero serif subtle mouse interaction --- */
  function initHeroSerif() {
    const serif = document.querySelector('.klemm-hero-serif[data-interactive]');
    if (!serif) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;
    let tx = 0, ty = 0, cx = 0, cy = 0;
    function onMove(e) {
      const r = serif.getBoundingClientRect();
      const mx = r.left + r.width / 2;
      const my = r.top + r.height / 2;
      tx = Math.max(-0.6, Math.min(0.6, (e.clientX - mx) / window.innerWidth));
      ty = Math.max(-0.6, Math.min(0.6, (e.clientY - my) / window.innerHeight));
    }
    function raf() {
      cx += (tx - cx) * 0.08;
      cy += (ty - cy) * 0.08;
      const skew = cx * 12;
      const scale = 1 + Math.abs(cy) * 0.15;
      const ls = (cx * 0.04).toFixed(4);
      serif.style.transform = 'skewX(' + -skew + 'deg) scale(' + scale + ')';
      serif.style.letterSpacing = ls + 'em';
      requestAnimationFrame(raf);
    }
    window.addEventListener('mousemove', onMove, { passive: true });
    requestAnimationFrame(raf);
  }

  function init() {
    initReveal();
    initNavScrolled();
    initLocalTime();
    initMarquee();
    initHeroSerif();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.Klemm = KL;
})();
